import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import SocialProof from './components/SocialProof';
import ClusterNavigation from './components/ClusterNavigation';
import WhatIsDevelopment from './components/WhatIsDevelopment';
import WhyDevelopmentNeeded from './components/WhyDevelopmentNeeded';
import SystemSection from './components/SystemSection';
import CompetencyDirections from './components/CompetencyDirections';
import CareerStages from './components/CareerStages';
import IndividualDevelopment from './components/IndividualDevelopment';
import IndividualPlans from './components/IndividualPlans';
import MentoringSection from './components/MentoringSection';
import TalentPool from './components/TalentPool';
import WhyTrainingFails from './components/WhyTrainingFails';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import FormatsSection from './components/FormatsSection';
import ProcessSection from './components/ProcessSection';
import WhenNeeded from './components/WhenNeeded';
import AboutTrainer from './components/AboutTrainer';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import StudyFurtherSection from './components/StudyFurtherSection';
import RoiCtaStrip from '@/components/feature/RoiCtaStrip';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import Footer from '@/components/feature/Footer';

const hubNavLinks = [
  { label: 'Направления', target: 'cluster' },
  { label: 'Система', target: 'system' },
  { label: 'Процесс', target: 'process' },
  { label: 'FAQ', target: 'faq' },
];

export default function PersonnelDevelopmentPage() {
  return (
    <>
      
      <SeoTitle title="Развитие персонала | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={hubNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <SocialProof />

        <div id="cluster">
          <ClusterNavigation />
        </div>

        <WhatIsDevelopment />
        <WhyDevelopmentNeeded />

        <div id="system">
          <SystemSection />
        </div>

        <CompetencyDirections />
        <CareerStages />
        <IndividualDevelopment />
        <IndividualPlans />
        <MentoringSection />
        <TalentPool />
        <WhyTrainingFails />
        <WhyProgramsWork />
        <CompanyResults />
        <FormatsSection />

        <div id="process">
          <ProcessSection />
        </div>

        <WhenNeeded />
        <AboutTrainer />
        <FAQSection />
        <LeadMagnetBlock variant="full" />
        <CTASection />
        <StudyFurtherSection />
        <RoiCtaStrip />
        <Footer />
      </div>
    </>
  );
}